/**
 * WPS Dental Theme - Main JavaScript
 *
 * @package WPS_Dental_Theme
 */

import { Navigation } from "./components/Navigation";
import { ConsultChoiceModal } from "./components/ConsultChoiceModal";
import { HeroAnimations } from "./animations/HeroAnimations";
import { ScrollAnimations } from "./animations/ScrollAnimations";
import { TextAnimations } from "./animations/TextAnimations";
import { SwiperAnimations } from "./animations/SwiperAnimations";


class WPSDentalTheme {
  constructor() {
    this.init();
  }


  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.onReady());
    } else {
      this.onReady();
    }
  }


  onReady() {
    this.initAnimations();
    this.initAOS();
    this.initStickyHeader();
    this.initFullScreenMenu();
    this.initSwipers();
    this.initAccordion();
    this.stickyNavNones();
    this.initConsultChoiceModal();
  }

  initConsultChoiceModal() {
    new ConsultChoiceModal();
  }

  initAOS() {
    if (typeof AOS !== "undefined") {
      AOS.init({
        duration: 800,
        easing: "ease-in-out-sine",
        once: true,
        offset: 100,
        delay: 0,
      });
      document.documentElement.classList.add("wps-aos-ready");
    }
  }


  initStickyHeader() {
    if (typeof jQuery !== "undefined") {
      jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 180) {
          jQuery(".header-sticky__wrapper").addClass("sticky");
        } else {
          jQuery(".header-sticky__wrapper").removeClass("sticky");
        }
      });
    }
  }


  initFullScreenMenu() {
    const menuToggleBtn = document.querySelector("#mobile-menu-trigger");
    const menuToggleBtn2 = document.querySelector("#mobile-menu-trigger1");
    const menuCollapseLinks = document.querySelectorAll(".collape-menu");
    const menuCloseBtn = document.querySelector(".close-btn");
    const fullScreenMenu = document.querySelector(
      ".wps-full-screen-menu__wrapper",
    );

    if (!fullScreenMenu) return;

    const parentMenu = fullScreenMenu.querySelectorAll(
      ".menu-item-has-children > a",
    );

    const handleCollapse = function (curr) {
      parentMenu.forEach((menu) => {
        const submenu = menu.nextElementSibling;
        const parent = menu.parentElement;

        if (curr === menu && parent.classList.contains("active")) return;

        menu.classList.remove("rotate");
        menu.classList.remove("active");
        if (submenu) {
          submenu.style.maxHeight = null;
        }
      });
    };

    const handleOpen = function () {
      fullScreenMenu.classList.add("active");
      document.body.classList.add("add-bg-color");
      document.body.style.overflow = "hidden";
    };

    const handleClose = function () {
      fullScreenMenu.classList.remove("active");
      document.body.classList.remove("add-bg-color");
      handleCollapse();
      document.body.style.overflow = "visible";
    };

    // Event listeners
    if (menuToggleBtn) {
      menuToggleBtn.addEventListener("click", function () {
        handleOpen();
      });
    }

    if (menuToggleBtn2) {
      menuToggleBtn2.addEventListener("click", function () {
        handleOpen();
      });
    }

    if (menuCloseBtn) {
      menuCloseBtn.addEventListener("click", function () {
        handleClose();
      });
    }

    menuCollapseLinks.forEach((link) => {
      link.addEventListener("click", function () {
        handleClose();
      });
    });

    // Recompute the max-height of any ancestor submenus so that opening or
    // closing a nested (2nd/3rd level) submenu doesn't get clipped by a parent
    // whose max-height was locked to an earlier scrollHeight.
    const refreshAncestorHeights = function (submenu) {
      let li = submenu.parentElement;
      let ancestor = li ? li.closest("ul.sub-menu") : null;
      while (ancestor) {
        ancestor.style.maxHeight = `${ancestor.scrollHeight}px`;
        const parentLi = ancestor.parentElement;
        ancestor = parentLi ? parentLi.closest("ul.sub-menu") : null;
      }
    };

    parentMenu.forEach((menu) => {
      menu.addEventListener("click", function (e) {
        e.preventDefault();
        const currentLink = menu;
        const submenu = currentLink.nextElementSibling;

        if (!currentLink.classList.contains("active")) {
          currentLink.classList.add("rotate");
          currentLink.classList.add("active");
          if (submenu) {
            submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            refreshAncestorHeights(submenu);
          }
        } else {
          currentLink.classList.remove("rotate");
          currentLink.classList.remove("active");
          if (submenu) {
            submenu.style.maxHeight = "0";
            refreshAncestorHeights(submenu);
          }
        }
      });
    });

    fullScreenMenu.addEventListener("click", function (e) {
      if (e.target === fullScreenMenu) {
        handleClose();
      }
    });

    window.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        handleClose();
      }
    });
  }


  initNavigation() {
    const nav = document.querySelector(".main-navigation");
    if (nav) {
      new Navigation(nav);
    }
  }


  initAnimations() {
    if (typeof gsap !== "undefined") {
      new HeroAnimations();
      new ScrollAnimations();
      new TextAnimations();
    }
  }


  initSwipers() {
    if (typeof Swiper !== "undefined") {
      new SwiperAnimations();
    }
  }
  initAccordion() {
    const section = document.querySelector(".wps-insidepage-faq-section");
    if (section) {
      const accordions = section.querySelectorAll(
        ".wps-insidepage-faq-section__item",
      );

      function collapseAll(current) {
        accordions.forEach((accordion) => {
          if (accordion === current) return;

          accordion.classList.remove("active");
        });
      }

      accordions.forEach((accordion) => {
        const question = accordion.querySelector(
          ".wps-insidepage-faq-section__question",
        );

        question.addEventListener("click", function () {
          collapseAll(accordion);
          accordion.classList.toggle("active");
        });
      });
    }
  }
  stickyNavNones() {
    const stickyNavNones = document.querySelectorAll(
      ".header-sticky__wrapper #main-menu a[href='#']"
    );

    stickyNavNones.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });
  }

}

// Initialize theme
new WPSDentalTheme();
